/**
 * Visually hidden, and still in the accessibility tree.
 *
 * `clip-path` rather than `display: none` or `visibility: hidden` — both of those remove the region
 * from the tree, which is the one thing this element exists to stay in. The 1px box is what keeps it
 * out of flow without collapsing it to nothing a reader will walk.
 */
.region {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
